import axios from "../../../../axios";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FaAngleRight } from "react-icons/fa";
import coin from "../../../../Images/adhyayi_coin.png";

const ChallengeCard = ({ hideTitle = false }) => {
  const [contests, setContests] = useState([]);

 useEffect(() => {
  const fetchContests = async () => {
    try {
      const response = await axios.get("getAllContestForUser");

      const contests = response?.data?.result || [];

      const today = new Date().toISOString().split("T")[0];

      const todayContests = contests.filter((contest) => {
        const contestDate = new Date(contest?.startTime)
          .toISOString()
          .split("T")[0];

        return contestDate === today;
      });

      if (todayContests.length > 0) {
        setContests(todayContests);
      } else {
        // latest contest fallback
        const sortedContests = [...contests].sort(
          (a, b) =>
            new Date(b?.startTime) - new Date(a?.startTime)
        );

        setContests(
          sortedContests.length > 0
            ? [sortedContests[0]]
            : []
        );
      }
    } catch (error) {
      console.error("Error fetching contest data:", error);
    }
  };

  fetchContests();
}, []);

  return (
    <div className="w-full h-full rounded-3xl p-2 sm:p-6 sm:mb-20 overflow-hidden">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-lg text-left font-bold text-[#171321] ">
          Challenges
        </h2>
        {/* <Link to="/dash/contest">
        <button className="flex items-center gap-2 text-sm font-semibold text-[#34163F]">
          View All <ArrowRight className="h-4 w-4" />
        </button>
        </Link> */}
      </div>

      {contests.length > 0 ? (
        <Swiper
          modules={[Autoplay]}
          spaceBetween={16}
          slidesPerView={1}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop={true}
          className="w-full"
        >
          {contests.map((contest, index) => {
            const isEnded = new Date(contest?.endTime) < new Date();

            return (
              <SwiperSlide key={contest._id || index}>
                <div className="bg-[#FFF3DD] rounded-2xl p-4 sm:p-5 sm:mb-15 border-2 border-purple-800">
                  <div className="flex justify-between items-start mb-3">
                    
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 pr-3">
                      {contest?.contestName || "Today's Contest"}
                    </h3>

                    <div
                      className={`flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${
                        isEnded
                          ? "bg-yellow-100 text-red-500"
                          : "bg-green-100 text-green-700"
                      }`}
                    >
                      <span
                        className={`w-2 h-2 rounded-full ${
                          isEnded ? "bg-red-500" : "bg-green-700"
                        }`}
                      ></span>

                      {isEnded ? "Ended" : "Live"}
                    </div>
                  </div>

                  <p className="text-sm text-left text-gray-600 mb-4">
                   <img src={coin} alt="coin" className="w-8 h-6 inline-block mr-1" />
                    <span className="font-bold text-black">
                      {contest?.prizePoolCoin || 2100}
                    </span> Credits Get reward of{" "}
                  </p>

                  <div className="flex items-center gap-3 mb-5">
                    <div className="flex -space-x-2">
                      <img
                        src="https://randomuser.me/api/portraits/women/1.jpg"
                        className="w-8 h-8 rounded-full border-2 border-white"
                        alt=""
                      />

                      <img
                        src="https://randomuser.me/api/portraits/men/2.jpg"
                        className="w-8 h-8 rounded-full border-2 border-white"
                        alt=""
                      />

                      <img
                        src="https://randomuser.me/api/portraits/women/3.jpg"
                        className="w-8 h-8 rounded-full border-2 border-white"
                        alt=""
                      />
                    </div>

                    <span className="text-gray-500 text-sm">
                      +{contest?.joinedUsersCount || 0} joined
                    </span>
                  </div>

                  <Link
                    to={isEnded ? "#" : "/dash/contest"}
                    onClick={(e) => isEnded && e.preventDefault()}
                  >
                 <button
  className={`w-full py-3 rounded-full text-white font-semibold text-sm sm:text-base transition-all duration-300 flex items-center justify-center gap-2 ${
    isEnded
      ? "bg-gray-400 cursor-not-allowed"
      :"bg-gradient-to-r from-[#1E0A2B] via-[#4B1D67] to-[#9333EA] hover:opacity-90"
  }`}
  disabled={isEnded}
>
  {isEnded ? (
    "Contest Ended"
  ) : (
    <>
      Join Contest
      <FaAngleRight />
    </>
  )}
</button>
                  </Link>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <div className="min-h-36 rounded-2xl bg-[#FAF8FC] border border-[#E7D7EE] flex items-center justify-center px-4 text-center">
          <p className="text-sm text-gray-500">No live contest right now</p>
        </div>
      )}
    </div>
  );
};

export default ChallengeCard;
